import { PharmacCheckbox, PharmacLabel } from '@pharmac/ui'
import { Controller } from 'react-hook-form'
import { ControlledInputProps } from './dto'

export type ControlledCheckboxProps = ControlledInputProps & {
  checkboxLabel: string
}

export const ControlledCheckbox = (props: ControlledCheckboxProps) => {
  const handleCheckboxChange = (checked: boolean) => {
    if (checked) return undefined
    return true
  }

  return (
    <>
      {!!props.label && <PharmacLabel marginSmallBottom>{props.label}</PharmacLabel>}
      <Controller
        name={props.name}
        control={props.control}
        rules={props.rules}
        render={({ field }) => {
          return (
            <PharmacCheckbox
              checked={!!field.value}
              handleChange={() => field.onChange(handleCheckboxChange(field.value))}
            >
              {props.checkboxLabel}
            </PharmacCheckbox>
          )
        }}
      />
    </>
  )
}
